import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { ThemePorvider } from './context';

ReactDOM.render(
  <React.StrictMode>
    <ThemePorvider>
      <App />
    </ThemePorvider>
  </React.StrictMode>,
  document.getElementById('root')
);
